<header data-test="ywXgvBhe" class="header-main">
  <div data-test="FLTUW8Ii" class="header">
    <div data-test="ISC3Jdi7" class="header__container modules-container">
      <div
        data-test="3zEeqS2l"
        class="header__wrap row align-items-center flex-nowrap gutters-20"
      >
        <div
          data-test="ssubFpt5"
          class="header__col header__sidebar-button col-auto pr-0"
          (click)="handleSidebarIconClick()"
        >
          <button
            data-test="UPpWo7gP"
            class="header__sidebar-open icon"
            data-show="sidebar-modules"
          >
            <i data-test="cpWW9b3_" class="material-icons md-24">menu</i>
          </button>
        </div>
        <div data-test="jXEP5VPw" class="header__col col">
          <h1 data-test="9gFlbQTc" class="header__title">{{ headerTitle }}</h1>
        </div>
        <div data-test="ueSCKuUb" class="header__col col-auto">
          <div data-test="NIiOuIg5" class="header__nav row align-items-center gutters-16">
            <!--<div class="col-auto">
              <form class="search-top">
                <button class="search-top__toggle js-toggle-search" type="button">
                  <svg class="icon__icon-search" width="18px" height="17.5px">
                    <use xlink:href="#icon-search"></use>
                  </svg>
                </button>
                <div class="search-top__field">
                  <input
                    class="search__input search__input_icon input input_sm input_bb input_bb-hover"
                    id="topSearch"
                    type="search"
                    placeholder="Search"
                  />
                  <label class="search-top__label" for="topSearch">Search</label>
                </div>
              </form>
            </div>-->
            <div
              data-test="LerkpBMF"
              class="header__profile col-auto pointer"
              [mdPopover]="userActionsMenu"
            >
              <md-letter-image
                data-test="WQokfGZW"
                class="img-square img-square_md"
                *ngIf="
                  currentUserService.user$ | async | notNull as user;
                  else emptyAvatar
                "
                [name]="user | fullname"
                [image]="user.contactPhotoFilename"
              ></md-letter-image>
              <ng-template #emptyAvatar>
                <div
                  data-test="_00PKfrn"
                  class="img-square img-square_md"
                  style="background-image: url('assets/img/content/humans/avatar.svg')"
                ></div>
              </ng-template>
              <i data-test="2oyqdid8" class="material-icons md-16 ml-1">
                keyboard_arrow_down
              </i>
              <span
                class="notification-count"
                data-test="wVfmATgd"
                [ngClass]="{ zero: totalNotificationCount === 0 }"
              >
                {{ totalNotificationCount }}
              </span>
            </div>
            <div
              data-test="mLKzHQ-M"
              class="dropdown dropdown_bottom-right dropdown_arrow"
              style="right: 4px"
              #userActionsMenu
            >
              <div data-test="zQ0CXsiy" class="dropdown__wrap">
                <ul data-test="7xyRyAiR" class="dropdown__menu">
                  <li
                    data-test="JmhgvjNO"
                    class="dropdown__menu-item"
                    [routerLink]="['/personal-profile']"
                    tabIndex="-1"
                  >
                    <a data-test="tcv2BXHf" class="dropdown__menu-link">My profile</a>
                  </li>

                  <li data-test="GwE7SFcX" class="dropdown__menu-item">
                    <md-notifications-menu-item
                      data-test="ieNSpMc9"
                      (countChange)="updateTotalCount($event)"
                    ></md-notifications-menu-item>
                  </li>

                  <li data-test="9SQfQBd-" class="dropdown__menu-item">
                    <md-assignments-menu-item
                      data-test="QY8o9Kei"
                      (countChange)="updateTotalCount($event)"
                    ></md-assignments-menu-item>
                  </li>
                  <li
                    data-test="Ykyf1aCT"
                    class="dropdown__menu-item"
                    (mousedown)="logout()"
                  >
                    <a data-test="TmMwPmIx" class="dropdown__menu-link">Logout</a>
                  </li>
                </ul>
              </div>
            </div>
            <!--<div class="col-auto">
              <button class="header__button icon icon_md" type="button" data-show="sidebar">
                <svg class="icon__icon-notification" width="12px" height="17px">
                  <use xlink:href="#icon-notification"></use>
                </svg>
                <span class="header__nav-notification-badge badge badge_notification">5</span>
              </button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
</header>
